// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HMO73u3RmDmHrG {
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-250, 20px) var(--ds-space-200, 14px) var(--ds-space-200, 14px);
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.HMO73u3RmDmHrG:hover,
.HMO73u3RmDmHrG:active {
  background-color: transparent;
  color: var(--ds-text-brand, #0c66e4);
  text-decoration: none;
}
.dtw7_AIh1GxqiV {
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-250, 20px) var(--ds-space-200, 14px) var(--ds-space-200, 14px);
  font-size: 16px;
  gap: var(--ds-space-050, 4px);
}
.dtw7_AIh1GxqiV:hover,
.dtw7_AIh1GxqiV:active {
  background-color: transparent;
  color: var(--ds-text-brand, #0c66e4);
  text-decoration: none;
}
.dtw7_AIh1GxqiV svg {
  width: 8px;
  height: auto;
}
.dtw7_AIh1GxqiV[data-active='true'] {
  color: var(--ds-text-brand, #0c66e4);
}
.FTFYbJ74oZPCew {
  display: flex;
  position: relative;
}
.TZwczZVliJ1vHC {
  position: absolute;
  bottom: var(--ds-space-0, 0);
  height: 2px;
  transition: left 0.3s ease, width 0.3s ease;
  background-color: var(--ds-background-brand-bold, #0c66e4);
}
@media (prefers-reduced-motion: reduce) {
  .TZwczZVliJ1vHC {
    transition: none;
  }
}
`, ""]);
// Exports
export var tabLink = `HMO73u3RmDmHrG`;
export var tabButton = `dtw7_AIh1GxqiV`;
export var tabGroup = `FTFYbJ74oZPCew`;
export var underline = `TZwczZVliJ1vHC`;
export default ___CSS_LOADER_EXPORT___;
